import React from "react";
import { intl } from "LocaleWrapper";
import { IconButton, Popover } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import usePopover from "components/hooks/usePopover";
import { productLinkWithDetails } from "utils/productUtils";
import { ProductWithDetailsFragment } from "__generated__/view/products/graphql/product.fragments.generated";

const CallProductsPopover = ({ productsWithDetails }: { productsWithDetails?: ProductWithDetailsFragment[] | null }) => {

	const { popoverProps, onPopoverOpen } = usePopover({
		trigger: "click",
	});

	if (productsWithDetails?.length === 1) {
		return productLinkWithDetails(productsWithDetails[0]?.product, productsWithDetails[0]?.productDetails ?? "");
	} else if (productsWithDetails?.length === 2) {
		return (
			<React.Fragment>
				<span style={{ alignItems: "center", display: "flex" }}>
					{`${productsWithDetails.length} ${intl.formatMessage({ id: "PRODUCTS" })}`}

					<IconButton onClick={(event) => onPopoverOpen(event)} size="small">
						<InfoOutlinedIcon fontSize="small" />
					</IconButton>
				</span>

				<Popover {...popoverProps}>
					<div style={{ padding: 16 }}>
						{productsWithDetails.map((p, index) => (
							<div key={index}>
								{productLinkWithDetails(p?.product, p?.productDetails ?? "")}
							</div>
						))}
					</div>
				</Popover>
			</React.Fragment>
		);
	} else {
		return <React.Fragment />;
	}
};

export default CallProductsPopover;
